.monaco-editor .overlayWidgets{left:0;position:absolute;top:0}